import { Ref, ref } from 'vue'

import {
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import { HandballAttributeId } from '@collector/sportsapi-client-legacy'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import { useAttributeSelection } from './useAttributeSelection'

interface UsePositionSelections {
  pitchDistance: Ref<PitchDistance | null>
  pitchPosition: Ref<PitchPosition | null>
  goalPosition: Ref<GoalPosition | null>
}

export function usePositionSelections(
  linkedIncident: ProbableLinkedIncident,
  removeAttribute: (attribute: HandballAttributeId) => void,
  addAttribute: (attribute: HandballAttributeId) => void,
  distanceAttributeMap: Map<PitchDistance, HandballAttributeId>,
  positionAttributeMap: Map<PitchPosition, HandballAttributeId>,
  goalPositionAttributeMap?: Map<GoalPosition, HandballAttributeId>,
): UsePositionSelections {
  const { selectedValue: pitchDistance } = useAttributeSelection(
    linkedIncident,
    removeAttribute,
    addAttribute,
    distanceAttributeMap,
  )

  const { selectedValue: pitchPosition } = useAttributeSelection(
    linkedIncident,
    removeAttribute,
    addAttribute,
    positionAttributeMap,
  )

  const { selectedValue: goalPosition } = goalPositionAttributeMap
    ? useAttributeSelection(
        linkedIncident,
        removeAttribute,
        addAttribute,
        goalPositionAttributeMap,
      )
    : { selectedValue: ref<GoalPosition>(null) }

  return {
    pitchDistance,
    pitchPosition,
    goalPosition,
  }
}
